<template>
  <div class="header" :style="{ position: position, top: top }">
    <div class="headerLeft" @click="logoClick()">
      <img src="../assets/header/logo.png" alt="" />
    </div>
    <div class="headerRight">
      <div
        class="active"
        v-for="(item, index) in flarr"
        :key="index"
        :class="{ activeColor: everyid == index }"
      >
        <div class="title" @click="link(index)" @mouseenter="mouseOver(index)">
          {{ item.nickname }}
          <!-- <div class="red" v-if="everyid == index"></div> -->
        </div>
      </div>
    </div>
    <div class="button" v-if="!login" @click="loginjump()">登录</div>
    <div v-if="login">
      <el-dropdown>
        <span class="el-dropdown-link">
          <img
            :src="touxiang"
            style="width: 0.32rem; height: 0.32rem; margin-right: 0.08rem"
            alt=""
          />
          {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleClick('0')"
            >控制台</el-dropdown-item
          >
          <el-dropdown-item @click.native="handleClick('1')"
            >退出登录</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 方案中心 -->
    <div
      class="schemeBox schemeBot"
      @mouseleave="mouseLeave"
      :style="{ height: schemeHeight, opacity: schemeOpcity }"
    >
      <div class="itemBox" v-show="schemeShow">
        <div class="scheme" v-for="(item, index) in scheme" :key="index">
          <div class="schemeTitle" @click="schemeNick(item)">
            {{ item.nickname }}
          </div>
          <div class="chemeLine"></div>
          <div
            class="schemeText"
            v-for="(itemS, indexS) in item.list ? item.list.slice(0, 7) : []"
            :key="indexS"
            @click="schemeClick(itemS)"
          >
            {{ itemS.title }}
          </div>
          <div
            class="ellipsis"
            @click="dScheme()"
            v-if="item.list ? item.list.length > 7 : 0"
          >
            ...
          </div>
        </div>
      </div>
    </div>
    <!-- 产品中心 -->
    <div
      class="schemeBox"
      @mouseleave="mouseProduct"
      :style="{ height: productHeight, opacity: productOpcity }"
    >
      <div class="itemBox" v-show="productShow">
        <div class="scheme" v-for="(item, index) in product" :key="index">
          <div class="schemeTitle" @click="productNick(item)">
            {{ item.nickname }}
          </div>
          <div class="chemeLine"></div>
          <div
            class="schemeText"
            v-for="(itemS, indexS) in item.list ? item.list.slice(0, 7) : []"
            :key="indexS"
            @click="productClick(itemS)"
          >
            {{ itemS.title }}
          </div>
          <div
            class="ellipsis"
            @click="dProduct()"
            v-if="item.list ? item.list.length > 7 : 0"
          >
            ...
          </div>
        </div>
      </div>
    </div>
    <!-- 案例中心 -->
    <div
      class="schemeBox"
      @mouseleave="mouseCase"
      :style="{ height: caseHeight, opacity: caseOpcity }"
    >
      <div class="itemBox" v-show="caseShow">
        <div class="scheme" v-for="(item, index) in cases" :key="index">
          <div class="schemeTitle" @click="caseNick(item)">
            {{ item.nickname }}
          </div>
          <div class="chemeLine"></div>
          <div
            class="schemeText"
            v-for="(itemS, indexS) in item.list ? item.list.slice(0, 7) : []"
            :key="indexS"
            @click="casesClick(itemS)"
          >
            {{ itemS.title }}
          </div>
          <div
            class="ellipsis"
            @click="dCase()"
            v-if="item.list ? item.list.length > 7 : 0"
          >
            ...
          </div>
        </div>
      </div>
    </div>
    <!-- 生态合作 -->
    <div
      class="schemeBox"
      @mouseleave="mouseHabits"
      :style="{ height: habitsHeight, opacity: habitsOpcity }"
    >
      <div class="itemBox" v-show="habitShow">
        <div class="scheme">
          <div class="schemeTitle">生态伙伴</div>
          <div class="chemeLine"></div>
          <!-- <div class="schemeText" @click="sClick">生态合作</div> -->
          <div class="schemeText" @click="cClick">成为生态伙伴</div>
          <div class="schemeText" @click="xClick">查询生态伙伴</div>
          <div class="schemeText" @click="fClick">赋能生态伙伴</div>
        </div>
        <div class="scheme">
          <div class="schemeTitle">企业服务</div>
          <div class="chemeLine"></div>
          <div class="schemeText" @click="zClick">中小企业综合服务平台</div>
        </div>
        <div class="scheme">
          <div class="schemeTitle">应用市场</div>
          <div class="chemeLine"></div>
          <div class="schemeText" @click="yClick">应用市场</div>
        </div>
        <div class="scheme">
          <div class="schemeTitle">产业生态</div>
          <div class="chemeLine"></div>
          <div class="schemeText" @click="iClick">产业生态伙伴</div>
        </div>
      </div>
    </div>
    <!-- 开发者中心 -->
    <div
      class="schemeBox"
      @mouseleave="mouseDecelop"
      :style="{ height: developHeight, opacity: developOpcity }"
    >
      <div class="itemBox" v-show="developShow">
        <div class="scheme">
          <div class="schemeTitle">产品知识库</div>
          <div class="chemeLine"></div>
          <div class="schemeText" @click="developNick">产品知识库</div>
        </div>
        <div class="scheme">
          <div class="schemeTitle">开放平台</div>
          <div class="chemeLine"></div>
          <div class="schemeText" @click="api">开放平台</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { routerIndex: 0 },
  data() {
    return {
      scrollTopNum: "",
      position: "",
      top: "",
      // 方案中心
      schemeShow: false,
      schemeHeight: 0,
      schemeOpcity: 0,
      // 产品中心
      productShow: false,
      productHeight: 0,
      productOpcity: 0,
      // 案例中心
      caseShow: false,
      caseHeight: 0,
      caseOpcity: 0,
      // 生态合作
      habitShow: false,
      habitsHeight: 0,
      habitsOpcity: 0,
      // 开发者中心
      developShow: false,
      developHeight: 0,
      developOpcity: 0,
      everyid: this.routerIndex ? this.routerIndex : 0,
      flarr: [
        {
          nickname: "首页",
          link: "/",
        },
      ],
      // 方案中心
      scheme: [],
      // 产品中心
      product: [],
      //案例中心
      cases: [],
      // 生态合作
      habits: [
        // {
        //   nickname: "生态伙伴",
        //   list: [
        //     {
        //       title: "生态合作",
        //       link: "http://www.sieiot.com/common/eco_become/",
        //     },
        //   ],
        // },
        // {
        //   nickname: "部委合作",
        //   list: [
        //     {
        //       title: "专精特新梯度培养平台",
        //       link: "http://iidp.chinasie.com/iidp/zxqyfwpt/",
        //     },
        //   ],
        // },
        // {
        //   nickname: "应用市场",
        //   list: [
        //     {
        //       title: "应用市场",
        //       link: "/habits",
        //     },
        //   ],
        // },
      ],
      // 是否登录
      login: false,
      touxiang: "",
      name: "",
      toplist: [],
    };
  },
  created() {},
  mounted() {
    // 取出本地数据头像姓名token，先验证token
    console.log(JSON.parse(localStorage.getItem("token")));
    if (JSON.parse(localStorage.getItem("token")) != null) {
      // 本地有token
      // 使用全局方法验证token
      this.$fun.detetoken();
      // 拿到头像姓名
      this.touxiang = JSON.parse(localStorage.getItem("avatar"));
      this.name = JSON.parse(localStorage.getItem("nickname"));
      this.login = true;
    } else {
      this.login = false;
    }
    let navigationData = window.sessionStorage.getItem("navigationData");
    if (navigationData) {
      this.flarr = JSON.parse(navigationData);
    } else {
      this.getLink();
    }
    this.getLinkList();
    this.getLinkList2();
    this.getLinkList3();
    // this.getLinkList4();
  },
  watch: {
    scrollTopNum: function () {
      console.log(scrollTopNum);
      if (this.scrollTopNum > 200) {
        this.position = "fixed";
        this.top = "0.23rem";
      } else if (this.scrollTopNum < 630) {
        this.top = "";
        this.position = "";
      }
    },
    $route(to, from) {},
  },
  methods: {
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      this.scrollTopNum = top;
      console.log(top);
    },
    logoClick() {
      this.$router.push({
        path: "/",
      });
    },
    dScheme() {
      this.$router.push({
        path: "/scheme",
      });
    },
    dProduct() {
      this.$router.push({
        path: "/product",
      });
    },
    dCase() {
      this.$router.push({
        path: "/case",
      });
    },
    // 跳转到login页面
    loginjump() {
      this.$router.push({
        path: "/login",
      });
    },
    // 退出登录
    handleClick(command) {
      if (command == "1") {
        console.log("退出登录");
        // 清除数据
        localStorage.removeItem("avatar");
        localStorage.removeItem("nickname");
        localStorage.removeItem("token");
        this.login = false;
      } else if (command == "0") {
        console.log("跳转控制台");
        var account = JSON.parse(localStorage.getItem("account"));
        var password = JSON.parse(localStorage.getItem("password"));
        var token = JSON.parse(localStorage.getItem("token"));
        var loginPath = '/admin/index/ajax_login?token='
        var loginUrl = window.location.origin + loginPath
        console.log(account, password, token);
        window.open(
          loginUrl + token,
          "_blank"
        );
        // this.$fun.getK()
        // this.$http({
        //   url: "/index/ajax_login?", //请求的后台接口
        //   method: "get", //get请求方式
        //   params: {
        //     username: account,
        //     password: password,
        //   }, //传给后台的参数
        // }).then(({ data }) => {
        //   console.log("成功=》", data);
        //   window.open(data.data, "_blank");
        // });
      }
    },
    // 导航栏一级
    getLink() {
      this.$http({
        url: "/index/categorylist", //请求的后台接口
        method: "get", //get请求方式
      }).then(({ data }) => {
        this.flarr = this.flarr.concat(data.data);
        window.sessionStorage.setItem(
          "navigationData",
          JSON.stringify(this.flarr)
        );
      });
    },
    // 导航栏二级
    getLinkList() {
      this.$http({
        url: "/index/categorylist2", //请求的后台接口
        method: "get", //get请求方式
        params: {
          pid: 1,
        },
      }).then(({ data }) => {
        this.scheme = data.data;
      });
    },
    getLinkList2() {
      this.$http({
        url: "/index/categorylist2", //请求的后台接口
        method: "get", //get请求方式
        params: {
          pid: 5,
        },
      }).then(({ data }) => {
        this.product = data.data;
      });
    },
    getLinkList3() {
      this.$http({
        url: "/index/categorylist2", //请求的后台接口
        method: "get", //get请求方式
        params: {
          pid: 6,
        },
      }).then(({ data }) => {
        this.cases = data.data;
      });
    },
    // getLinkList4() {
    //   this.$http({
    //     url: "/index/categorylist2", //请求的后台接口
    //     method: "get", //get请求方式
    //     params: {
    //       pid: 18,
    //     },
    //   }).then(({ data }) => {
    //     this.habits = data.data;
    //     console.log(this.habits);
    //   });
    // },
    // 跳转至方案中心页
    schemeNick(item) {
      this.$router.push({
        path: item.link,
        query: { id: item.id },
      });
    },
    // 方案中心跳转详情页
    schemeClick(itemS) {
      this.$emit("getDetails", itemS.id);
      this.$router.push({
        path: "/scheme_article",
        query: { id: itemS.id },
      });
    },
    // 跳转至产品中心页
    productNick(item) {
      this.$router.push({
        path: item.link,
        query: { id: item.id },
      });
    },
    // 产品中心跳转详情页
    productClick(itemS) {
      this.$emit("getDetails", itemS.id);
      this.$router.push({
        path: itemS.html_enum == "a" ? "/productInfo" : "/productTwo",
        query: { id: itemS.id },
      });
    },
    // 跳转至案例中心页
    caseNick(item) {
      this.$router.push({
        path: item.link,
        query: { id: item.id },
      });
    },
    // 案例中心跳转详情页
    casesClick(itemS) {
      this.$emit("getDetails", itemS.id);
      this.$router.push({
        path: "/caseInfo",
        query: { id: itemS.id },
      });
    },
    // 生态合作
    // sClick() {
    //   window.open("http://www.chinasie.com/common/", "_blank");
    // },
    // 成为生态伙伴
    cClick() {
      window.open("http://www.chinasie.com/eco_join/", "_blank");
    },
    // 查询生态伙伴
    xClick() {
      window.open("http://www.chinasie.com/eco_result/", "_blank");
    },
    // 赋能生态伙伴
    fClick() {
      window.open("http://www.chinasie.com/eco_empowerment/", "_blank");
    },
    zClick() {
      // 取出本地数据头像姓名token，先验证token
      console.log(JSON.parse(localStorage.getItem("token")));
      if (JSON.parse(localStorage.getItem("token")) != null) {
        // 本地有token
        // 使用全局方法验证token
        this.$fun.detetoken();
        // 全局跳转内网控制台
        this.$fun.controll();
      } else {
        // 否则没登陆需跳转到登录页
        this.open3();
        this.loginjump();
      }
    },
    yClick() {
      this.$router.push({
        path: "/habits",
      });
    },
    iClick() {
      this.$router.push({
        path: "/industry",
      });
    },
    // 开发者中心
    developNick() {
      let routeData = this.$router.resolve({
        path: "/developerinfo",
      });
      //必要操作，否则不会打开新页面
      window.open(routeData.href, "_blank");
    },
    api() {
      // 取出本地数据头像姓名token，先验证token
      console.log(JSON.parse(localStorage.getItem("token")));
      if (JSON.parse(localStorage.getItem("token")) != null) {
        // 本地有token
        // 使用全局方法验证token
        this.$fun.detetoken();
        // 全局方法拿到内网token
        this.$fun.gettoken2();
      } else {
        // 否则没登陆需跳转到登录页
        this.open3();
        this.loginjump();
      }
    },
    open3() {
      this.$message({
        message: "请先登录",
        type: "warning",
      });
    },
    // 跳转到login页面
    loginjump() {
      this.$router.push({
        path: "/login",
      });
      //必要操作，否则不会打开新页面
      // window.open(routeData.href, "_blank");
    },
    link(index) {
      if (this.everyid === index);
      this.everyid = index;
      this.$router.push({
        path: this.flarr[index].link,
      });
    },
    // 移入
    mouseOver(index) {
      if (index === 1) {
        this.schemeOpcity = 1;
        this.schemeHeight = "auto";
        this.schemeShow = true;
        this.productShow = false;
        this.caseShow = false;
        this.habitShow = false;
      } else if (index === 2) {
        this.productOpcity = 1;
        this.productHeight = "auto";
        this.productShow = true;
        this.schemeShow = false;
        this.caseShow = false;
        this.habitShow = false;
        this.developShow = false;
      } else if (index === 3) {
        this.caseOpcity = 1;
        this.caseHeight = "auto";
        this.caseShow = true;
        this.schemeShow = false;
        this.productShow = false;
        this.habitShow = false;
        this.developShow = false;
      } else if (index === 4) {
        this.habitsOpcity = 1;
        this.habitsHeight = "auto";
        this.habitShow = true;
        this.schemeShow = false;
        this.productShow = false;
        this.caseShow = false;
        this.developShow = false;
      } else if (index === 5) {
        this.developOpcity = 1;
        this.developHeight = "auto";
        this.developShow = true;
        this.habitShow = false;
        this.schemeShow = false;
        this.productShow = false;
        this.caseShow = false;
      }
    },
    // 移出
    mouseLeave() {
      this.developShow = false;
      this.schemeShow = false;
      this.productShow = false;
      this.caseShow = false;
      this.habitShow = false;
      this.schemeOpcity = 0;
      this.schemeHeight = 0;
    },
    mouseProduct() {
      this.developShow = false;
      this.schemeShow = false;
      this.productShow = false;
      this.caseShow = false;
      this.habitShow = false;
      this.productOpcity = 0;
      this.productHeight = 0;
    },
    mouseCase() {
      this.developShow = false;
      this.schemeShow = false;
      this.productShow = false;
      this.caseShow = false;
      this.habitShow = false;
      this.caseOpcity = 0;
      this.caseHeight = 0;
    },
    mouseHabits() {
      this.developShow = false;
      this.schemeShow = false;
      this.productShow = false;
      this.caseShow = false;
      this.habitShow = false;
      this.habitsOpcity = 0;
      this.habitsHeight = 0;
    },
    mouseDecelop() {
      this.developShow = false;
      this.schemeShow = false;
      this.productShow = false;
      this.caseShow = false;
      this.habitShow = false;
      this.habitsOpcity = 0;
      this.habitsHeight = 0;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.28rem 1.8rem 0.24rem;
  z-index: 9;
  box-shadow: 0px 0.04rem 0.32rem rgba(0, 0, 0, 0.06);
  position: relative;

  .headerLeft {
    width: 1.4rem;
    height: 0.32rem;
  }

  .headerRight {
    display: flex;
    height: 0.26rem;

    .active {
      color: #131313;
      opacity: 0.8;
      font-size: 0.16rem;
      font-weight: 400;
      margin-left: 0.64rem;
      cursor: pointer;
      height: 0.26rem;
      line-height: 0.26rem;
    }
    .active:hover {
      font-weight: 700;
      opacity: 1;
    }
    .activeColor {
      color: #131313;
      opacity: 1;
      font-weight: 700;
    }

    .red {
      width: 0.32rem;
      height: 0.04rem;
      background: #cf094b;
      margin: 0.06rem auto 0;
      transition: all 0.5s;
    }
  }
}

.active:hover {
  border-bottom: 0.04rem solid #cf094b;
}
.active:nth-child(2):hover .schemeBox {
  opacity: 1;
  height: 4rem;
  z-index: 9999;
}

.schemeBox {
  position: absolute;
  top: 0.8rem;
  left: 0;
  width: 100%;
  transition: all 0.5s;

  .itemBox {
    display: flex;
    padding: 0 0 0.36rem 1.8rem;
    background: #fff;
    flex-wrap: wrap;
  }

  .scheme {
    width: 1.4rem;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    padding-right: 0.96rem;

    .ellipsis {
      font-size: 0.16rem;
      cursor: pointer;
    }

    .schemeTitle {
      color: #333333;
      font-weight: 700;
      font-size: 0.2rem;
      cursor: pointer;
      margin-top: 0.4rem;
    }

    .chemeLine {
      width: 1.4rem;
      height: 0.01rem;
      background: #e8e8e8;
      margin-top: 0.16rem;
    }

    .schemeText {
      color: #333333;
      font-weight: 300;
      font-size: 0.16rem;
      margin-top: 0.2rem;
      transition: all 0.3s;
      cursor: pointer;
      white-space: nowrap;
    }

    .schemeText:hover {
      color: #cf094b;
    }
  }
}
.header .schemeBot {
  .scheme:nth-child(1) {
    width: 1.46rem;
  }
}
.header .schemeBot {
  .scheme:nth-child(2) {
    width: 2.5rem;
  }
}
.button {
  width: 0.76rem;
  height: 0.34rem;
  border: 1px solid #cf094b;
  border-radius: 100px;
  font-weight: 400;
  font-size: 0.14rem;
  line-height: 0.34rem;
  text-align: center;
  color: #cf094b;
  cursor: pointer;
}
.button:hover {
  background: #cf094b;
  color: #ffffff;
}
.el-dropdown-link {
  cursor: pointer;
  letter-spacing: 0.04em;
  font-size: 0.16rem;
  color: #31373d;
  display: flex;
  align-items: center;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
